import {
  IPackageMethod,
  ITabGame,
  ITopupGameDetail,
  ITopupPackage,
  ITopupSelectedData,
  OnePackage
} from "@/app/interfaces/ITopup"
import TopupService from "@/app/services/services/TopupService"
import { convertObjectToArray } from "@/app/utils"
import { useTranslation } from "next-i18next"
import { useRouter } from "next/router"
import React, {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState
} from "react"
import { LoadingTopup } from "./LoadingTopup"
import { NguyenbaoGamota } from "./NguyenBaoGamota"
import useGAEventsTracker from "@/app/hooks/useGAEventsTracker"
import { AppContext } from "@/app/context"
import { Button } from "@/app/components/ui/button"
import GiftIcon from "public/img/gift_icon_2.png"
import Image from "next/image"

interface TopupPackageAndMethodProps {
  packageAndTab: ITopupPackage
  selectedTab: ITabGame | undefined
  handleChangeSelectedTab: (tab: ITabGame) => void
  selectedData: ITopupSelectedData
  setSelectedData: Dispatch<SetStateAction<ITopupSelectedData>>
  setLoading: Dispatch<SetStateAction<boolean>>
  loading: boolean
  setRenderMethods: Dispatch<SetStateAction<IPackageMethod[]>>
  renderMethods: IPackageMethod[]
  extendData?: {
    alreadyGoldGift: number
    totalLimit: number
  } | null
  listPackageType: "image" | "text"
  gameDetail: ITopupGameDetail
}

export const PackageAndMethod: React.FC<TopupPackageAndMethodProps> = ({
  packageAndTab,
  selectedTab,
  handleChangeSelectedTab,
  selectedData,
  setSelectedData,
  setLoading,
  loading,
  renderMethods,
  setRenderMethods,
  extendData,
  listPackageType,
  gameDetail
}) => {
  const { t } = useTranslation()
  const router = useRouter()
  const { userInfo } = useContext(AppContext)
  const [renderPackage, setRenderPackage] = useState<OnePackage[]>([])
  const GAEventsTracker = useGAEventsTracker("Store_TopupGame")

  const handleSelectRenderPackageWhenChangeTab = () => {
    if (!selectedTab) {
      const result = convertObjectToArray(packageAndTab?.packages)

      setRenderPackage(result)
      setSelectedData({
        ...selectedData,
        selectPackage: result[0]
      })
      return result
    }

    const filterObject = Object.fromEntries(
      Object.entries(packageAndTab?.packages).filter(([key]) =>
        selectedTab?.package?.includes(key)
      )
    )

    const _package = convertObjectToArray(filterObject)

    if (_package?.length) {
      setRenderPackage(_package)
      const firstPackage = _package[0]
      setSelectedData({
        ...selectedData,
        selectPackage: firstPackage
      })
    }
  }

  const getMethodByPackageId = async (slug_name: string, v3_id: string) => {
    setLoading(true)

    try {
      if (
        !!slug_name &&
        !!v3_id &&
        !!selectedData?.selectUser?.user_id &&
        !!selectedData?.selectServer?.server_id &&
        !!selectedData?.selectRole?.role_id
      ) {
        const res = await TopupService.getMethodByPackageId({
          slug_name,
          v3_id,
          user_id: selectedData?.selectUser?.user_id,
          server_id: selectedData?.selectServer?.server_id,
          role_id: selectedData?.selectRole?.role_id,
          platform: selectedData?.selectPlatform?.platform_id
        })
        if (res?.data?.errorCode === 0) {
          const methods = convertObjectToArray(res?.data?.data?.methods || {})
          setRenderMethods([...methods])
          setSelectedData({
            ...selectedData,
            selectMethod: methods[0],
            hoverDescription: res?.data?.data?.v3_description
          })
        }
      }
      setLoading(false)
    } catch (err) {
      setLoading(false)
    } finally {
    }
  }

  useEffect(() => {
    handleSelectRenderPackageWhenChangeTab()
  }, [selectedTab, packageAndTab])

  useEffect(() => {
    if (!!router?.query?.slug_name && !!selectedData?.selectPackage?.v3_id) {
      getMethodByPackageId(
        String(router?.query?.slug_name),
        selectedData?.selectPackage?.v3_id
      )
    }
  }, [router?.query?.slug_name, selectedData?.selectPackage?.v3_id])

  const onChangeSelectPackage = (item: OnePackage) => {
    if (!loading) {
      GAEventsTracker("Store_Topup_package", "Search User info")
      setSelectedData({
        ...selectedData,
        selectPackage: item
      })
    }
  }
  const onChangeSelectMethod = (item: IPackageMethod) => {
    if (!loading) {
      // GAEventsTracker("Store_Topup_package")
      if (
        item.method !== "gamota_la" ||
        selectedData.selectPackage.v3_amount <= userInfo.total_la
      )
        setSelectedData({
          ...selectedData,
          selectMethod: item
        })
    }
  }

  return (
    <div className="w-full lg:mb-[28px]">
      <section className="topup-package pb-[100px] md:pb-0">
        <p className="text-[16px] Nunito-700 hidden md:block">
          1. {t("topup.select_package")}
        </p>
        {!!packageAndTab?.tabGame && packageAndTab?.tabGame?.length ? (
          <div className="block mt-[12px] flex gap-[12px] flex-wrap">
            {!!packageAndTab?.tabGame &&
              packageAndTab?.tabGame?.map((tab: ITabGame) => {
                return (
                  <button
                    className={`Nunito-600 text-sm w-fit px-[16px] rounded-[12px] h-[31px] ${
                      selectedTab?.id === tab?.id
                        ? "bg-main-01 text-white"
                        : "border border-black/10 text-main-text-color bg-white dark:bg-white/10 dark:text-white"
                    }`}
                    key={tab?.id}
                    onClick={() => handleChangeSelectedTab(tab)}
                  >
                    {tab?.name}
                  </button>
                )
              })}
          </div>
        ) : (
          <></>
        )}

        {/* Nguyên bảo Tiếu ngạo Gamota */}
        {!!extendData && (
          <NguyenbaoGamota
            current={extendData?.alreadyGoldGift ?? 0}
            maxValue={extendData?.totalLimit ?? 0}
          />
        )}

        {loading ? (
          <LoadingTopup />
        ) : (
          Array.isArray(renderPackage) && (
            <div
              className={`w-full grid ${
                listPackageType === "image"
                  ? "grid-cols-3 sm:grid-cols-4"
                  : "grid-cols-1 md:grid-cols-2 lg:grid-cols-2"
              } gap-x-[24px] gap-y-[16px] mt-[16px]`}
            >
              {renderPackage.map((item: OnePackage) => {
                // console.log(item?.v3_id, selectedData?.selectPackage?.v3_id)
                const is_selected =
                  (item?.v3_id === selectedData?.selectPackage?.v3_id &&
                    !!item?.v3_id) ||
                  (item?.package_id ===
                    selectedData?.selectPackage?.package_id &&
                    !!item?.package_id)
                return (
                  <div
                    key={item?.v3_id || item?.package_id}
                    onClick={() => {
                      onChangeSelectPackage(item)
                    }}
                    className={`${
                      is_selected
                        ? "border border-[1px] border-main-01 dark:border-color-border text-main-01"
                        : "dark:bg-block-color dark:border-white/10 border border-white border-[1px]"
                    } ${
                      listPackageType === "image"
                        ? "overflow-hidden"
                        : "px-[16px] py-[14px]"
                    } rounded-[12px] cursor-pointer flex items-center bg-white dark:bg-white/10`}
                  >
                    {listPackageType === "image" ? (
                      <img
                        src={item.v3_image || item.image_url}
                        alt={item?.v3_title || item?.package_title}
                        className="w-full aspect-square"
                      />
                    ) : (
                      <>
                        {is_selected ? (
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              width="16"
                              height="16"
                              rx="8"
                              fill="#7673E6"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M11.7509 5.22127C11.9048 5.35982 11.9173 5.59692 11.7787 5.75087L7.90995 10.0495C7.42268 10.5909 6.59774 10.6584 6.02896 10.2034L4.26575 8.79283C4.10403 8.66345 4.07781 8.42747 4.20719 8.26574C4.33657 8.10402 4.57255 8.0778 4.73427 8.20718L6.49749 9.61775C6.75602 9.82458 7.13099 9.7939 7.35248 9.54781L11.2213 5.24914C11.3598 5.0952 11.5969 5.08272 11.7509 5.22127Z"
                              fill="#FAF8FF"
                            />
                          </svg>
                        ) : (
                          <div className="w-[16px] h-[16px] rounded-[16px] bg-button"></div>
                        )}
                        <p className="text-[14px] Nunito-700 ml-[16px] flex-1 mr-2">
                          {item?.v3_title || item?.package_title}
                        </p>

                        <span
                          className={`ml-auto mr-0 ${
                            is_selected
                              ? "text-main-red-02"
                              : "text-main-red-02 dark:text-main-white"
                          } text-[16px] Nunito-700 whitespace-nowrap dark:bg-white/10 dark:px-[12px] dark:py-[4px] dark:rounded-[8px]`}
                        >
                          {item?.v3_amount &&
                            `đ ${item?.v3_amount?.toLocaleString()}`}
                          {item?.package_amount &&
                            `${item?.package_amount?.toLocaleString()} ${
                              item?.currency
                            }`}
                        </span>
                      </>
                    )}
                  </div>
                )
              })}

              {/* quà trợ lực  */}
              {listPackageType === "image" ? (
                <div
                  onClick={() => {
                    router.push(
                      `/giftcode?game_id=${gameDetail?.game_id}&type=game`
                    )
                  }}
                  className="w-full h-full bg-qua-tro-luc-image rounded-[12px] overflow-hidden cursor-pointer aspect-square"
                ></div>
              ) : (
                <div
                  onClick={() => {
                    router.push(
                      `/giftcode?game_id=${gameDetail?.game_id}&type=game`
                    )
                  }}
                  className={`bg-qua-tro-luc flex items-center gap-[6px] dark:bg-block-color dark:border-white/10 border border-white border-[1px] px-[16px] py-[14px] rounded-[12px] cursor-pointer flex items-center bg-white dark:bg-white/10`}
                >
                  <Image src={GiftIcon} alt="gift" width={32} height={32} />
                  <span className="text-white Nunito-700 text-[14px]">
                    {t("store.power_gift")}
                  </span>
                </div>
              )}
            </div>
          )
        )}
      </section>
      {!!selectedData?.selectPackage?.v3_id && (
        <section className="package-method mt-[28px] lg:my-[28px] hidden md:block">
          <p className="text-[16px] Nunito-700 pb-[16px] hidden md:block">
            2. {t("topup.select_method")}
          </p>
          <div className="w-full grid grid-cols-1 gap-[16px] lg:mb-[100px]">
            {!!Array.isArray(renderMethods) &&
              renderMethods.map((item: IPackageMethod) => (
                <div
                  key={`${item?.method}-${item?.item?.package_id}-${selectedData?.selectPackage?.v3_id}`}
                  onClick={() => {
                    onChangeSelectMethod(item)
                  }}
                  className={`${
                    item?.method === selectedData?.selectMethod?.method
                      ? "border-[1px] px-[24px] border-main-01"
                      : "px-[24px] dark:bg-block-color dark:border-white/10 border-white border-[1px]"
                  }  rounded-[12px] cursor-pointer flex items-center h-[54px] bg-white dark:bg-white/10`}
                >
                  <img
                    src={item?.icon}
                    className="w-[32px] h-[32px] rounded-[8px] mr-[10px] object-cover border border-black/10 dark:border-white/10"
                  />
                  <div
                    className={`${
                      item.method === "gamota_la" &&
                      selectedData?.selectPackage?.v3_amount >
                        userInfo?.total_la &&
                      "opacity-60"
                    }`}
                  >
                    <p
                      className={`text-[14px] Nunito-700 leading-[14px] ${
                        item.method === "gamota_la" && "text-[#E8A236]"
                      }`}
                    >
                      {item?.name}
                    </p>
                    {item.method === "gamota_la" && (
                      <p className="text-[#E8A236] text-[12px] Nunito-500">
                        {t("store.la_number", {
                          number: userInfo?.total_la?.toLocaleString()
                        })}
                      </p>
                    )}
                  </div>
                  {item.method === "gamota_la" &&
                  selectedData?.selectPackage?.v3_amount >
                    userInfo?.total_la ? (
                    <Button
                      variant="main"
                      className="h-[24px] ml-auto text-[12px] Nunito-SemoBold opacity-160"
                      onClick={() => {
                        router.push("/topup/napla")
                      }}
                    >
                      {t("store.la_invoice")}
                    </Button>
                  ) : (
                    <div className="relative ml-auto group">
                      <p className="mr-0 text-sm text-right Nunito-700">
                        đ {item?.item?.amount?.toLocaleString()}
                      </p>
                      <p className="mr-0 text-xs text-right text-main-01 Nunito-600">
                        {item?.item?.value} {item?.item?.currency}
                      </p>
                      {!!selectedData?.hoverDescription && (
                        <div className="absolute bottom-6 z-10 scale-0 min-w-[300px] max-w-[300px] rounded-2xl Nunito-500 bg-white p-4 transition-all text-sm text-main-text-color border border-input-border-light group-hover:scale-100">
                          {selectedData?.hoverDescription}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))}
          </div>
        </section>
      )}
    </div>
  )
}
